import { useCallback, useEffect, useRef } from 'react';
import { useScreenOrientationChange } from '@/hooks/useScreenOrientationChange';
import useScript from '@/hooks/useScript';
import { EmbedFacebookService } from '@/services/embed-facebook';
import { type IEmbedFacebook } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Facebook ({ id }: IEmbedFacebook) {
  useScript('https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v20.0');

  const embedRef = useRef(null);
  const handleRenderEmbed = useCallback(() => {
    /**
     * Timeout added because globalThis.FB.XFBML.parse need
     * a brief moment to find out that Screen Orientation changed
     *
     * Also, it makes a little bit of optimization for Interaction to Next Paint
     */
    setTimeout(() => {
      if (globalThis.FB && embedRef.current) {
        globalThis.FB.XFBML.parse(embedRef.current);
      }
    }, 50);
  }, [embedRef]);

  useEffect(handleRenderEmbed, [handleRenderEmbed]);
  useScreenOrientationChange({ callback: handleRenderEmbed });

  let embedAttributes;

  try {
    const embedHref = EmbedFacebookService.getEmbedHref({ url: id });
    const embedType = EmbedFacebookService.getEmbedType({ href: embedHref });
    embedAttributes = EmbedFacebookService.getEmbedAttributes({ href: embedHref, postType: embedType });
  } catch (e) {
    console.error('RTC / Embeds / Facebook: Rendering the Facebook Post Embed failed!', id, e);
    return <></>;
  }

  return (
    <div className={styles['facebook-post']} ref={embedRef}>
      <div {...embedAttributes} />
    </div>
  );
}
